import React, { useState, useEffect } from 'react';
// import { useNavigate} from 'react-router-dom';
import './writehere.css';
import Navbar from '../Navbar';

// import Web3 from 'web3';
import './StartWrtingComp.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faTimes } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom'


export default function WriteHere() {
    const navigate = useNavigate();

    const handleSubmit = () => {
        
        fetch('https://blissregency.com/shareitlater.php', {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            
          },
          body: new URLSearchParams(formdata).toString(),
        })
          .then(response => response.json())
          .then(data => {
           
            // Handle success or failure response
            console.log(data);
           
          })
          .catch(error => {
            alert("Your DAO Is Not Submitted,Please Try Again Later...");
            console.error('Error submitting form:', error);
          });
          navigate('/ShowApprove');
      };
      
    const [trusteeCount, setTrusteeCount] = useState(2);
    // const [tokenCount, setTokenCount] = useState(0);
    // const [nfttokenCount, setnftTokenCount] = useState(0);
    const selblockchain=localStorage.getItem('selectedOption');
    const daoname=localStorage.getItem('daoname');
    const trustee1wallet=localStorage.getItem('trustee1wallet');
    const trustee1email=localStorage.getItem('trustee1email');
    const trustee2wallet=localStorage.getItem('trustee2wallet');
    const trustee2email=localStorage.getItem('trustee2email');
    const trustee3wallet=localStorage.getItem('trustee3wallet');
    const trustee3email=localStorage.getItem('trustee3email');
    const trustee4wallet=localStorage.getItem('trustee4wallet');
    const trustee4email=localStorage.getItem('trustee4email');
    const successorwallet=localStorage.getItem('successorwallet');
    const successoremail=localStorage.getItem('successoremail');
    const token=localStorage.getItem('token');
    const seltoken=localStorage.getItem('seltoken');
    const nfttoken=localStorage.getItem('nfttoken');
    const formdata={
        'selectedblockchain':selblockchain,
        'daoname':daoname,
        'trustee1wallet':trustee1wallet,
        'trustee2wallet':trustee2wallet,
        'trustee3wallet':trustee3wallet,
        'trustee4wallet':trustee4wallet,
        'trustee1email':trustee1email,
        'trustee2email':trustee2email,
        'trustee3email':trustee3email,
        'trustee4email':trustee4email,
        'successoremail':successoremail,
        'successorwallet':successorwallet,
        'selectedtoken':seltoken,
        'token':token,
        'nfttoken':nfttoken
    }
    const removedata=()=>{
        localStorage.setItem('selectedOption','');
        localStorage.setItem('daoname','');
        localStorage.setItem('trustee1wallet','');
        localStorage.setItem('trustee1email','');
        localStorage.setItem('trustee2wallet','');
        localStorage.setItem('trustee2email','');
        localStorage.setItem('trustee3wallet','');
        localStorage.setItem('trustee3email','');
        localStorage.setItem('trustee4wallet','');
        localStorage.setItem('trustee4email','');
        localStorage.setItem('successorwallet','');
        localStorage.setItem('successoremail','');
        localStorage.setItem('token','');
        localStorage.setItem('seltoken','');
        localStorage.setItem('nfttoken','');
      
        
       
    }
    const handleUnsetLocalStorage = () => {
      localStorage.setItem('selectedOption','');
          localStorage.setItem('daoname','');
          localStorage.setItem('trustee1wallet','');
          localStorage.setItem('trustee1email','');
          localStorage.setItem('trustee2wallet','');
          localStorage.setItem('trustee2email','');
          localStorage.setItem('trustee3wallet','');
          localStorage.setItem('trustee3email','');
          localStorage.setItem('trustee4wallet','');
          localStorage.setItem('trustee4email','');
          localStorage.setItem('successorwallet','');
          localStorage.setItem('successoremail','');
          localStorage.setItem('token','');
          localStorage.setItem('seltoken','');
          localStorage.setItem('nfttoken','');
  
      // Optional: Clear any other localStorage variables if needed
  
      // Navigate to the current location
      navigate('/writehere');
    };
  const [add,setAdd]=useState(false);
  useEffect(() => {
    if (localStorage.getItem('address')) {
        setAdd(true);
    }
}, [add]);

    const addTrustee = () => {
      if (trusteeCount === 2) {
        setTrusteeCount(3);
      } else if (trusteeCount === 3) {
        setTrusteeCount(4);
      }
    }
    const removeTrustee = (index) => {
        setTrusteeCount(trusteeCount - 1);
        // Perform any additional removal logic here
      };
      // const addToken = () => {
      //   if (tokenCount === 0) {
      //     setTokenCount(1);
      //   } else if (tokenCount === 1) {
      //     setTokenCount(2);
      //   }
      // }
      // const removeToken = (index) => {
      //     setTokenCount(tokenCount - 1);
      //     // Perform any additional removal logic here
      //   };
      //   const addnftToken = () => {
      //       if (nfttokenCount === 0) {
      //         setnftTokenCount(1);
      //       } else if (nfttokenCount === 1) {
      //         setnftTokenCount(2);
      //       }
      //     }
      //     const removenftToken = (index) => {
      //         setnftTokenCount(nfttokenCount - 1);
      //         // Perform any additional removal logic here
      //       };
 

    return (
        <>
        <Navbar showMenu={false}  />
        {
            add ?(
<section id="writehere" style={{ position: 'relative' }}>
                <div className="container page-content d-flex justify-content-center align-items-center flex-column mt-5">
                    <h1>Write here now, we will share it later</h1>

                  
                        <div className="writeherecard">
                        <div className="container">
                        <form id='startWritingForm' onSubmit={handleSubmit}>
                        <div class="mb-3">
                        <label for="blockchain_name" class="form-label">SELECTED BLOCKCHAIN</label>
                        <input style={{background:'hwb(186 24% 10%)',color:'black'}} type="text" name='selectedblockchain' className="form-control bg-yellow mb-3"id="blockchain_name" placeholder="SELECTED BLOCKCHAIN" defaultValue={selblockchain} />
                    </div>
                    <div class="mb-3">
                        <label for="dao_name" class="form-label">NAME OF YOUR ShareitLater DAO</label>
                        <input style={{background:'hwb(186 24% 10%)',color:'black'}} type="text" name='daoname' className="form-control bg-honeydew mb-3" id="dao_name" placeholder="Your DAO name" defaultValue={daoname}/>
                    </div>
                    <div class="mb-4">
                        <label for="s_wallet" class="form-label">YOUR SUCCESSORS’ CRYPTO WALLET ADDRESSES
                            <br />
                           
                        </label>

                        <input type="text" style={{background:'hwb(186 24% 10%)',color:'black'}} name='successorwallet' className="form-control bg-honeydew mb-3" id="s_wallet" placeholder="SUCCESSORS’ Wallet" defaultValue={successorwallet} />
                        <input type="email" style={{background:'hwb(186 24% 10%)',color:'black'}} name='successoremail' className="form-control bg-honeydew mb-3"id="s_email" placeholder="SUCCESSORS’ Email " defaultValue={successoremail}/>
                    </div>
                    <div class="mb-4">
                        <label for="t_wallet" class="form-label">YOUR TRUSTEES’ CRYPTO WALLET ADDRESSES

                       
                            
                        </label>
                        <br />
                        <span class="form-label px-3">1
                            </span>
                        <input type="text" style={{background:'hwb(186 24% 10%)',color:'black'}} class="form-control bg-honeydew mb-3" name='trustee1wallet' id="t_wallet 1_t" placeholder="TRUSTEES’ Wallet" defaultValue={trustee1wallet} />
                        <input type="email" style={{background:'hwb(186 24% 10%)',color:'black'}} class="form-control bg-honeydew mb-4" name='trustee1email'id="t_email 1_e" placeholder="TRUSTEES’ Email " defaultValue={trustee1email} />
                        <span class="form-label px-3">2
                            </span>
                        <input type="text" style={{background:'hwb(186 24% 10%)',color:'black'}} class="form-control bg-honeydew mb-3" name='trustee2wallet' id="t_wallet 2_t" placeholder="TRUSTEES’ Wallet" defaultValue={trustee2wallet}/>
                        <input type="email" style={{background:'hwb(186 24% 10%)',color:'black'}} class="form-control bg-honeydew mb-4" name='trustee2email' id="t_email 2_e" placeholder="TRUSTEES’ Email" defaultValue={trustee2email} />
                       
                        { (trusteeCount>=3 && trustee3wallet) && (
                            
                            <>
                            
                             <FontAwesomeIcon icon={faTimes} onClick={() => removeTrustee(3)}  style={{ fontSize: '1.5rem', cursor: 'pointer', marginRight: '0.5rem' ,left:'88%',position:'sticky' ,background:'black',borderRadius:'4px'}}/>
                        <input type="text" style={{background:'hwb(186 24% 10%)',color:'black'}} class="form-control bg-honeydew mb-3" name='trustee3wallet' id="t_wallet 3_t" placeholder="TRUSTEES’ Wallet" defaultValue={trustee3wallet} />
                       
                        <input type="email" style={{background:'hwb(186 24% 10%)',color:'black'}} class="form-control bg-honeydew mb-4" name='trustee3email' id="t_email 3_e" placeholder="TRUSTEES’ Email " defaultValue={trustee3email}/>
                     
                       </> )}
                      
                       { (trusteeCount>=4 && trustee4wallet) && (
                            <>
                            <FontAwesomeIcon icon={faTimes} onClick={() => removeTrustee(4)}  style={{ fontSize: '1.5rem', cursor: 'pointer', marginRight: '0.5rem',left:'88%',position:'sticky',background:'black',borderRadius:'4px'  }}/>
                        <input type="text" style={{background:'hwb(186 24% 10%)',color:'black'}}  className="form-control bg-honeydew mb-3" name='trustee4wallet' id="t_wallet 4_t" placeholder="TRUSTEES’ Wallet" defaultValue={trustee4wallet}/>
                        
                        <input type="email" style={{background:'hwb(186 24% 10%)',color:'black'}}  className="form-control bg-honeydew mb-3" name='trustee4email' id="t_email 4_e" placeholder="TRUSTEES’ Email " defaultValue={trustee4email} />
                       
                        </> )}
                        { (trusteeCount<4 && (trustee3wallet || trustee4wallet)) && (
                    <div class="mb-4 d-flex align-items-center justify-content-center">
                        <button class="btn rounded-pill px-5
                        " id='addtrustee' onClick={addTrustee} type="button">
                            SHOW TRUSTEE
                        </button>
                    </div>
                        )}
                        <div class="mb-3">
                        <label for="blockchain_name" class="form-label">ENTRUSTED TOKENS</label>
                        <input style={{background:'hwb(186 24% 10%)',color:'black'}} type="text" class="form-control bg-honeydew" name='selectedtoken' id="blockchain_name" placeholder="SELECTED Token from list" defaultValue={seltoken}/>
                        <input style={{background:'hwb(186 24% 10%)',color:'black'}} type="text" class="form-control bg-honeydew" id="blockchain_name" name='token' placeholder="entered token" defaultValue={token}/>
                        <input style={{background:'hwb(186 24% 10%)',color:'black'}} type="text" class="form-control bg-honeydew" id="blockchain_name" name='nfttoken' placeholder="entered nft token" defaultValue={nfttoken} />
                    </div>
                        
                        </div>
                        <div class="mb-4 d-flex align-items-center justify-content-center">
                            {/* <Link to={{
                                pathname:'/WriteHere',
                            }}> */}
                                 <button type='submit' class="btn rounded-pill px-5" 
                        onClick={removedata}
                        >
                           APPROVE
                           </button>
                            
                            
                            
                        
                        <button type='button' class="btn rounded-pill px-5" 
                        onClick={handleUnsetLocalStorage}
                        >
                           Cancel
                           </button>
                            
                            
                            
                       
                            {/* </Link> */}
                       
                    </div>
                        </form>
                            </div>
                            </div>
                        
                    
                </div>
            </section>
            ):(
<section id="writehere" style={{ position: 'relative' }}>
                <div className="container page-content d-flex justify-content-center align-items-center flex-column mt-5">
                    <h1>Please Connect Wallet First</h1>
                    </div>
                    </section>
            )
        }
            
            
        </>
    );
}
